import { createStandardAction } from 'typesafe-actions';
import { IAskToResumeOnVisitOverlay } from './types';

export const updateAskToResumeOnVisitOverlay = createStandardAction(
  'askToResumeOverlay/UPDATE_VISIBLE'
)<IAskToResumeOnVisitOverlay | undefined>();
